import { Link, useLocation } from 'react-router-dom';
import { ThemeToggle } from './ThemeToggle';

const TEST_FLOW_PATH_PATTERN = /^\/(vorbereitung|kontext|test|pruefen)/;

/** Kopfbereich mit Titel, Link zur Methodik-Seite und Theme-Umschaltung. */
export function SiteHeader() {
  const location = useLocation();
  const isDuringTest = TEST_FLOW_PATH_PATTERN.test(location.pathname);

  return (
    <header className="site-header no-print">
      <div className="page-container site-header__inner">
        <Link to="/" className="site-header__brand">
          Passt Instagram als Sichtbarkeitskanal?
        </Link>
        <nav aria-label="Hauptnavigation" className="site-header__nav">
          {!isDuringTest && <Link to="/ueber-den-test">Über den Test</Link>}
          <ThemeToggle />
        </nav>
      </div>
    </header>
  );
}
